export const REACTION_PAGE_SIZE = 20;

export const PACK_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'DRAFT', label: '草稿' },
  { value: 'ACTIVE', label: '上架' },
  { value: 'INACTIVE', label: '下架' },
  { value: 'BANNED', label: '封禁' },
];

export const PACK_STATUS_FORM_OPTIONS = PACK_STATUS_OPTIONS.filter((o) => o.value);

export const ACCESS_TYPE_OPTIONS = [
  { value: 'FREE', label: 'FREE' },
  { value: 'VIP_SUBSCRIPTION', label: 'VIP_SUBSCRIPTION' },
  { value: 'PERMANENT_PURCHASE', label: 'PERMANENT_PURCHASE' },
  { value: 'LIMITED_EVENT', label: 'LIMITED_EVENT' },
  { value: 'CUSTOM', label: 'CUSTOM' },
];

export function buildReactionPackPageParams(pageNo, filters = {}, pageSize = REACTION_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.status) params.status = filters.status;
  if (filters.name?.trim()) params.name = filters.name.trim();
  return params;
}

export function formatPackStatus(status) {
  return PACK_STATUS_FORM_OPTIONS.find((o) => o.value === status)?.label || status || '—';
}

export const EMPTY_PACK_FORM = {
  name: '',
  coverEmoji: '👍',
  publisherDisplayName: 'Formosa',
  visibility: 'PUBLIC',
  accessType: 'FREE',
  subscriptionRequirement: '',
  status: 'ACTIVE',
  description: '',
  category: 'DEFAULT',
  tags: '',
  sort: 0,
  version: 1,
};

export const EMPTY_EMOJI_FORM = {
  emoji: '',
  code: '',
  name: '',
  keywords: '',
  renderType: 'UNICODE',
  status: 'ACTIVE',
  sort: 0,
};
